// File: noviopus-ats-client/src/features/OnBoardingFlow/selectors.ts
import { createSelector } from 'reselect';
import { safeGet } from '@/utils/safeImmutable';

// 1. Safe Slice Extraction
const selectDomain = (state: any) => safeGet(state, 'onBoardingFlow');

export const selectOnboardingState = createSelector(
  [selectDomain],
  (subState) => {
    // Modern Slice is always POJO. 
    // safeGet handles if it was somehow wrapped in Immutable during hydration.
    const state = subState && typeof subState.toJS === 'function' ? subState.toJS() : subState;
    
    return state || {
      stage: 0,
      isCompleted: false,
      isLoading: true,
      trackSteps: [],
      trackName: 'DEFAULT',
      redirectPath: null,
      initialRedirectComplete: false
    };
  }
);

// 2. Safe Field Access (POJO)
export const selectIsOnboardingCompleted = createSelector(
  [selectOnboardingState],
  (onboarding) => onboarding.isCompleted
);

export const selectStage = createSelector(
  [selectOnboardingState],
  (onboarding) => onboarding.stage
);

export const selectTrackSteps = createSelector(
  [selectOnboardingState],
  (onboarding) => onboarding.trackSteps
);

export const selectRedirectPath = createSelector(
  [selectOnboardingState],
  (onboarding) => onboarding.redirectPath
);

export const selectIsLoading = createSelector(
  [selectOnboardingState],
  (onboarding) => onboarding.isLoading
);